import React from 'react';
import { GridCellParams, GridColDef, GridValueGetterParams } from '@mui/x-data-grid-pro';
import { CatalogWorkunit } from 'types/entities/CatalogWorkunit';
import NameCell from '../../Cells/NameCell/NameCell';
import OrderAffectationScopeCell from '../../Cells/DataGridScopeCell/OrderAffectationScopeCell';
import PurchaseOrderCell from '../../Cells/PurchaseOrderCell/PurchaseOrderCell';
import ReferenceCell from '../../Cells/ReferenceCell/ReferenceCell';
import WorkloadCell from '../../Cells/WorkloadCell/WorkloadCell';
import PriceCell from '../../Cells/PriceCell/PriceCell';
import TotalCell from '../../Cells/TotalCell/TotalCell';
import ComplexityCell from '../../Cells/ComplexityCell/ComplexityCell';

type CatalogWorkunitDatagridCellParams<T> = GridCellParams<CatalogWorkunit, T, any>;

export const CatalogWorkunitDatagridfield = {
  REFERENCE: 'reference',
  NAME: 'name',
  COMPLEXITY: 'complexity_name',
  WORKLOAD: 'charge',
  PRICE: 'price',
  SCOPE: 'scope',
  PURCHASEORDER: 'purchase order',
  MONTHS: 'months',
  CONTENTS: 'contents',
  TOTAL: 'total',
};

export const catalogWorkunitDatagridColumnsParams: GridColDef[] = [
  {
    field: CatalogWorkunitDatagridfield.REFERENCE,
    headerName: 'Reference',
    minWidth: 110,
    renderCell: (params: CatalogWorkunitDatagridCellParams<string>) => <ReferenceCell reference={params.value || ''} />,
  },
  {
    field: CatalogWorkunitDatagridfield.NAME,
    headerName: 'Name',
    minWidth: 170,
    renderCell: (params: CatalogWorkunitDatagridCellParams<string>) => <NameCell name={params.value || ''} />,
  },
  {
    field: CatalogWorkunitDatagridfield.COMPLEXITY,
    headerName: 'Complexity',
    minWidth: 140,
    valueGetter: (params: GridValueGetterParams<CatalogWorkunit['complexity_name'], CatalogWorkunit>) =>
      params.row.complexity_name || params.row.complexity?.name || '',
    renderCell: (params: CatalogWorkunitDatagridCellParams<CatalogWorkunit['complexity_name']>) => (
      <ComplexityCell name={params.value} />
    ),
  },
  {
    field: CatalogWorkunitDatagridfield.WORKLOAD,
    headerName: 'Workload',
    minWidth: 50,
    renderCell: (params: CatalogWorkunitDatagridCellParams<number>) => <WorkloadCell charge={params.value || 0} />,
  },
  {
    field: CatalogWorkunitDatagridfield.PRICE,
	headerName: 'Price',
    minWidth: 50,
    renderCell: (params: CatalogWorkunitDatagridCellParams<number>) => <PriceCell price={params.value || 0} />,
  },
  {
    field: CatalogWorkunitDatagridfield.SCOPE,
    headerName: 'Scope',
    minWidth: 140,
    renderCell: (params: CatalogWorkunitDatagridCellParams<CatalogWorkunit>) => (
      <OrderAffectationScopeCell row={params.row} cellType="catalog" />
    ),
  },
  {
    field: CatalogWorkunitDatagridfield.PURCHASEORDER,
	headerName: 'Purchase_Order',
    minWidth: 220,
    renderCell: (params: CatalogWorkunitDatagridCellParams<CatalogWorkunit>) => (
      <PurchaseOrderCell row={params.row} cellType="catalog" />
    ),
  },
  {
    field: CatalogWorkunitDatagridfield.MONTHS,
  },
  {
    field: CatalogWorkunitDatagridfield.CONTENTS,
  },
  {
    field: CatalogWorkunitDatagridfield.TOTAL,
    headerName: 'Total',
    align: 'center',
    headerAlign: 'center',
    minWidth: 60,
    renderCell: (params: CatalogWorkunitDatagridCellParams<number>) => (
      <TotalCell total={params.value ? params.value : 0} />
    ),
  },
];
